import ElectronIPC from '@/services/ElectronIPC'
import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'
import { NewsCard } from '@/pages/DashboardPage/internal/useFrontpage'

type AppNewsCard = {
    card: NewsCard
}

export default function AppNewsCard({ card }: AppNewsCard): JSX.Element {
    const { cardTitle, messageTitle, message, callToActionLink, callToActionText, imageLinkUrl, imageUrl } = card
    const hasImage = imageUrl && imageUrl.length > 0
    const hasCallToAction = callToActionLink && callToActionText
    return (
        <div className="w-full h-full flex bg-[rgba(21,21,21,0.85)] border-muse-toplit-low rounded-[26px] shadow-glow">
            <div
                className={cn(
                    'h-full px-8 py-4 lg:px-12 lg:py-8 pr-1 flex flex-col',
                    cardTitle || !hasCallToAction ? 'justify-between' : 'justify-end',
                    hasImage ? 'w-[47%]' : 'w-full'
                )}
            >
                {cardTitle && <span className="opacity-50 t-sm">{cardTitle}</span>}
                <div className="flex flex-col gap-3 lg:gap-5 w-full flex-end">
                    <div className="text-lg w-full">{messageTitle}</div>
                    <div
                        className={cn(
                            't-sm-light w-full text-muse-fg/75 max-h-[80px] lg:max-h-[120px] overflow-y-auto pr-1'
                        )}
                    >
                        {message}
                    </div>
                    {hasCallToAction && (
                        <Button
                            variant="glow"
                            className="border-muse-toplit-low t-sm"
                            onClick={() => {
                                ElectronIPC.openLinkInBrowser(callToActionLink)
                            }}
                        >
                            {callToActionText}
                        </Button>
                    )}
                </div>
            </div>
            {hasImage && (
                <div
                    className={
                        "relative w-[53%] h-full t-base-bold bg-[url('/images/sparkle.webp')] flex items-center justify-center"
                    }
                >
                    <img
                        onClick={() => {
                            if (card.imageLinkUrl) {
                                ElectronIPC.openLinkInBrowser(card.imageLinkUrl)
                            }
                        }}
                        className={cn(
                            'max-w-[90%] max-h-[75%] hover:scale-105 transition-transform duration-150',
                            card.imageLinkUrl ? 'cursor-pointer' : ''
                        )}
                        src={card.imageUrl}
                    />
                </div>
            )}
        </div>
    )
}
